/** WhatsApp bill sharing through wa.me — no API key needed, one tap to send. */

export const waNumber = (mobile, countryCode = "91") => {
  const digits = String(mobile || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.length > 10 && digits.startsWith(countryCode)) return digits;
  if (digits.length === 10) return `${countryCode}${digits}`;
  return digits;
};

export const receiptLink = (invoice) => {
  if (!invoice?.public_token) return "";
  return `${window.location.origin}/receipt/${encodeURIComponent(invoice.invoice_no)}?t=${invoice.public_token}`;
};

const money = (n) => `Rs.${Number(n || 0).toFixed(2)}`;

export const billMessage = (invoice, shop, cfg = {}) => {
  const name = invoice.customer_name && invoice.customer_name !== "Walk-in Customer"
    ? invoice.customer_name
    : "Customer";
  const shopName = shop?.name || "Bharat Digital Seva";
  const greeting = (cfg.greeting || "Namaste {name}, your bill from {shop} is ready.")
    .replace("{name}", name)
    .replace("{shop}", shopName);

  const lines = [greeting, "", `*${shopName}*`, `Bill No: ${invoice.invoice_no}`, `Date: ${invoice.date} ${invoice.time || ""}`.trim()];

  if (cfg.include_items !== false) {
    lines.push("", "*Items*");
    (invoice.items || []).forEach((it) => {
      lines.push(`• ${it.product_name} × ${it.qty} = ${money(it.net_amount ?? it.amount)}`);
    });
  }

  lines.push("", `Subtotal: ${money(invoice.subtotal)}`);
  if (Number(invoice.discount_amount) > 0) {
    lines.push(`Discount${invoice.discount_percent ? ` (${invoice.discount_percent}%)` : ""}: -${money(invoice.discount_amount)}`);
  }
  lines.push(`*Total Paid: ${money(invoice.grand_total)}*`);
  lines.push(`Payment: ${invoice.payment_method}`);
  if (Number(invoice.due_amount) > 0) lines.push(`Balance Due: ${money(invoice.due_amount)}`);

  if (cfg.include_link !== false) {
    const link = receiptLink(invoice);
    if (link) lines.push("", "View / download your receipt:", link);
  }

  const offer = cfg.offer_line || "Visit us again — thank you for shopping with Bharat Digital Seva!";
  lines.push("", offer);
  if (cfg.signature) lines.push(`— ${cfg.signature}`);

  return lines.join("\n");
};

export const whatsappUrl = (invoice, shop, cfg = {}, mobileOverride) => {
  const number = waNumber(
    mobileOverride || invoice.customer_whatsapp || invoice.customer_mobile,
    cfg.country_code || "91"
  );
  const text = encodeURIComponent(billMessage(invoice, shop, cfg));
  return number ? `https://wa.me/${number}?text=${text}` : `https://wa.me/?text=${text}`;
};

export const shareOnWhatsapp = (invoice, shop, cfg = {}, mobileOverride) => {
  window.open(whatsappUrl(invoice, shop, cfg, mobileOverride), "_blank", "noopener");
};
